export const pagingSettings = {
  paging: { skip: 0, take: 20 }
};
